import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";

@autoinject
export class PromptDialog {
    constructor(protected controller: DialogController) {
    }

    question: string;
    answer: string;

    activate(question: string | object) {
        if (typeof question == "object") {
            const obj: any = question;
            this.question = obj.question;
            this.answer = obj.defaultValue;
        } else {
            this.question = question;
        }
    }
}